export class AttributeModel {
    fieldName: string;
    fieldType: string;
    fieldSetting: string;
    fieldEnable: boolean;
    fieldEnableValue: boolean;
    isBrand: boolean;
    isVideo: boolean;
    labelName: string;
    fieldValue: [{ fieldAttributeValue: string }] |  Array<any>
}